import { getFallbackValueIfNull } from 'owa-options-core';
import MessageFormatOptionState from '../store/schema/MessageFormatOptionState';
import store from '../store/store';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
import FontFlags from 'owa-service/lib/contract/FontFlags';

export interface IsMessageFormatOptionDirtyState {
    optionState: MessageFormatOptionState;
    userOptions: UserOptionsType;
}

export default select<IsMessageFormatOptionDirtyState>({
    optionState: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})(function isMessageFormatOptionDirty(state?: IsMessageFormatOptionDirtyState) {
    let { optionState, userOptions } = state;

    return (
        getFallbackValueIfNull(optionState.showBcc, userOptions.AlwaysShowBcc) !==
            userOptions.AlwaysShowBcc ||
        getFallbackValueIfNull(optionState.showFrom, userOptions.AlwaysShowFrom) !==
            userOptions.AlwaysShowFrom ||
        getFallbackValueIfNull(optionState.composeFormat, userOptions.ComposeMarkup) !==
            userOptions.ComposeMarkup ||
        getFallbackValueIfNull(optionState.fontFamily, userOptions.ComposeFontName) !==
            userOptions.ComposeFontName ||
        getFallbackValueIfNull(optionState.fontSize, userOptions.ComposeFontSize) !==
            userOptions.ComposeFontSize ||
        getFallbackValueIfNull(optionState.fontColor, userOptions.ComposeFontColor) !==
            userOptions.ComposeFontColor ||
        (optionState.isFontBold !== null &&
            !!(userOptions.ComposeFontFlags & FontFlags.Bold) !== optionState.isFontBold) ||
        (optionState.isFontItalic !== null &&
            !!(userOptions.ComposeFontFlags & FontFlags.Italic) !== optionState.isFontItalic) ||
        (optionState.isFontUnderline !== null &&
            !!(userOptions.ComposeFontFlags & FontFlags.Underline) !== optionState.isFontUnderline)
    );
});
